module.exports = __webpack_public_path__ + "img/Galileo_Half_Dark_675x315.3cd035da.png";